import { Checkbox, CheckboxGroup as MortarCheckboxGroup } from '@policygenius/mortar';
import React from 'react';
import { useFormState } from 'react-final-form';
import { createUseStyles } from 'react-jss';

import getErrorMessage from 'forms/getErrorMessage';

import { CheckboxGroupProps } from './types';
import styles from '../styles';
import useField from '../useField';

type Props = CheckboxGroupProps;
const useStyles = createUseStyles(styles);

const CheckboxGroup: React.FC<Props> = ({ name, config, options, ...props }) => {
  const classes = useStyles();
  const { input, meta } = useField(name, config);
  const { initialValues } = useFormState();

  return (
    <div className={classes.fieldContainer}>
      <MortarCheckboxGroup
        {...props}
        errorMessage={getErrorMessage(meta)}
        name={input.name}
        showGroupLabel
      >
        {options.map((option) => {
          const checkbox = useField<boolean, HTMLInputElement>(option.name, {
            type: 'checkbox',
            initialValue: initialValues?.[option.name] ?? false,
          });

          return (
            <Checkbox
              key={option.name}
              {...checkbox.input}
              label={option.label}
              value={option.name}
              onBlur={(e) => {
                checkbox.input.onBlur(e);
                input.onBlur(e);
              }}
              onChange={(e) => {
                const newVal = e.target.checked;

                option.onChange?.(newVal);
                checkbox.input.onChange(newVal);
              }}
              onFocus={(e) => {
                checkbox.input.onFocus(e);
                input.onFocus(e);
              }}
            />
          );
        })}
      </MortarCheckboxGroup>
    </div>
  );
};

export default CheckboxGroup;
